export const en = {
  set_created: 'set created successfully',
  set_updated: 'set updated successfully',
  set_should_have_one_word_at_least: 'set should have one word at least',
  the_word_should_be_unique: 'the word should be unique',
  type_set_name: 'type set name',
  edit_dashboard: 'edit dashboard',
  upload_csv_file: 'upload csv file',
  Drag_and_Drop_the_file_here: 'Drag and Drop the file here',
  or: 'Or',
  choose_file: 'Choose file',
  upload: 'upload',
  cancel: 'Cancel',
  Add_words: 'Add words',
  set_details: 'set details',
  sets: 'sets',
  search_by_set_name: 'search by set name',
  trash_icon: 'trashed',
  words: 'Words',
  word: 'Word',
  length_error_message: 'Set Name Must be at Least 3 Chars',
  repetition_error_message: 'This Set Name is already Taken',
  no_csv_file: 'choose CSV file',
  wrong_format: 'wrong format',
};
export const ar = {
  wrong_format: 'صيغة خاطئة',
  word: 'الكلمة',
  words: 'الكلمات',
  trash_icon: 'المحذوفات',
  Add_words: 'أضف كلمات',
  cancel: 'اغلاق',
  upload: 'تحميل',
  choose_file: 'أختر ملف',
  or: 'أو',
  Drag_and_Drop_the_file_here: 'قم بسحب وإسقاط الملف هنا',
  upload_csv_file: ' تحميل ملف csv',
  type_set_name: ' أكتب اسم المجموعة',
  the_word_should_be_unique: 'يجب أن تكون الكلمة فريدة',
  set_should_have_one_word_at_least: 'يجب ان يكون في  المجموعة كلمة علي الاقل',
  set_created: 'تم إنشاء المجموعة بنجاح',
  set_updated: 'تم تعديل المجموعة بنجاح',
  edit_dashboard: 'تعديل القائمة',
  set_details: ' تفاصيل المجموعة',
  sets: 'المجموعات',
  search_by_set_name: 'بحث بإسم المجموعة',
  repetition_error_message: 'اسم المجموعة هذا مأخوذ بالفعل',
  length_error_message: 'اسم المجموعة يجب ان لا يقل عن ثلاثه احرف',
  no_csv_file: ' قم بإختيار ملف csv',
};
